import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const config = {
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(config);

export const firestoreDb = getFirestore(
  app,
  process.env.REACT_APP_FIREBASE_FIRESTORE_NAME
    ? process.env.REACT_APP_FIREBASE_FIRESTORE_NAME
    : undefined
);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

export default app;
